import { usePathname, useSearchParams } from "next/navigation";
import DecorativeStars from "../../Icons/animations/DecorativeStars";
import SpinningStar from "../../Icons/animations/SpinningStars";
import { Link } from "../../Link/Link";

/*
 * On successful submission of a LeadForm we show a Thank You component.
 */
export const CareGiverLeadFormThankYou = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const closedDrawerPath = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.delete("leadVariant");

    const queryString = params.toString();
    const newPath = queryString ? `${pathname}?${queryString}` : pathname;

    return newPath;
  };

  return (
    <div className="flex w-full flex-col items-center gap-4 px-8 font-jakarta text-new-beginnings-base sm:px-12 md:w-[520px]">
      <div className="relative mt-16">
        <SpinningStar />
        <DecorativeStars />
      </div>
      <h2 className="font-bold text-lg">Thank you!</h2>
      <p className="mb-4 text-center">
        A care team member from your local Home Instead® office will be getting
        in touch with you shortly.
      </p>
      {/* Only show "Learn more about your local team" when we have their local office known */}
      {/* hidden until we decide on where this should link */}
      <Link className="hidden px-6" href={""}>
        Learn more about your local team
      </Link>
      <Link
        className="px-6 underline hover:no-underline"
        href={closedDrawerPath()}
        variant="plain"
      >
        Close this form
      </Link>
    </div>
  );
};
